module.exports = __webpack_public_path__ + "img/mesa_el_l.4f160a53.png";